const { getNumericValueWithDecimals } = require('../../analyticUtils');
const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createEcommerceEventGA4 } = require('../models/ecommerceEventGA4');
const {
  createEcommerceEventItemsGA4,
} = require('../models/ecommerceEventItemsGA4');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * WISHLIST EVENTS                                                            *
 * - Login link is clicked                                                    *
 * - Product is added                                                         *
 * - Product is removed                                                       *
 * - Share button is clicked                                                  *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  // Login link is clicked in Wishlist
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.wishlistLoginLinkClicked, () => {
    pushEvent(createCustomEventGA4('wishlist', [['action', 'login']]));
  });

  // Product is added to the wishlist
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.wishlistProductAdded,
    (payload) => {
      pushEvent(
        createEcommerceEventGA4(
          'add_to_wishlist',
          createEcommerceEventItemsGA4([
            {
              ...payload.product,
            },
          ]),
          {
            currency: gaInfo.currencyCode,
            value: getNumericValueWithDecimals(
              payload.product?.price?.sales?.decimalPrice
            ),
          }
        )
      );
    }
  );

  // Product is removed from the Wishlist
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.wishlistProductRemoved, () => {
    pushEvent(createCustomEventGA4('wishlist', [['action', 'remove-product']]));
  });

  // Share button of the Wishlist is clicked
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.wishlistShareButtonClicked,
    () => {
      pushEvent(createCustomEventGA4('wishlist', [['action', 'share']]));
    }
  );
}

module.exports = {
  subscribeToAnalyticsEvents,
};
